/** Visual identity only; never changes model admission, provider policy or routing. */
export type ModelBrand = 'gpt' | 'deepseek' | 'generic';

/** Semantic upstream names and historical IDs may contain a provider namespace. */
export function modelBrandForName(name?: string): ModelBrand {
  const value = name?.trim().toLowerCase().split('/').at(-1);
  if (value === 'gpt' || value?.startsWith('gpt-') || value?.startsWith('chatgpt-')) return 'gpt';
  if (value === 'deepseek' || value?.startsWith('deepseek-')) return 'deepseek';
  return 'generic';
}

/** Do not infer a brand from a supplier, user label or opaque configuration ID. */
export function platformModelBrand(model: {upstreamModel: string; capabilities: {family: 'gpt' | 'other'}}): ModelBrand {
  return model.capabilities.family === 'gpt' ? 'gpt' : modelBrandForName(model.upstreamModel);
}
